import styled, { css, keyframes } from 'styled-components';

const hideCardKeyframes = keyframes`
	0% {
		z-index: 1;
	}
	50% {
		z-index: 1;
	}
  51% {
    z-index: -1;
  }
	100% {
		z-index: -1;
	}
`;

const showCardKeyframes = keyframes`
  0% {
    z-index: -1;
  }
  50% {
    z-index: -1;
  }
  51% {
    z-index: 1;
  }
  100% {
    z-index: 1;
  }
`;

const StyledContainer = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	opacity: 0;
	transition: opacity 0.5s ease 0.1s;
`;

const StyledCardsContainer = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 2;
`;

const StyledCardContainer = styled.div<{
	$isEntering: boolean;
	$isExiting: boolean;
	$isHidden: boolean;
}>`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: ${(props) => (props.$isHidden ? -1 : 0)};

	${(props) =>
		props.$isEntering &&
		css`
			animation-name: ${showCardKeyframes};
		`}

	${(props) =>
		props.$isExiting &&
		css`
			animation-name: ${hideCardKeyframes};
		`}

  animation-duration: 510ms;
	animation-iteration-count: 1;
`;

const StyledPanelControlsContainer = styled.div`
	position: absolute;
	bottom: 60px;
	display: flex;
	justify-content: center;
	width: 100%;
`;

export {
	StyledContainer,
	StyledCardsContainer,
	StyledCardContainer,
	StyledPanelControlsContainer,
};
